// extracted by mini-css-extract-plugin
export default {"container":"register_container__7Spij"};